/**
 * @module components/MapColorSelector
 * @description 地图色阶选择器（Phase 5 迁移）
 *
 * 状态管理模式：
 *   读/写: useSettingObjectState('map_colors')
 */

import React, { useCallback } from 'react';
import { useIntl } from 'umi';
import { Button } from 'tea-component';
import ConfigCard from '@/pages/datalab/components/ConfigCard';
import ColorTheme from './ColorTheme';
import { useSettingObjectState } from '../../context';
import type { IMapColorsValue } from '../../types/settings/mapColors';
import { cloneMapColorsDefault } from '../../types/settings/mapColors';
import './index.scss';

/**
 * MapColorSelector — 地图图表色阶配置
 *
 * value 结构: { colorName: 'blue', colors: [{hexa, alpha}] }
 * hexa 格式: #RRGGBBAA（Alpha 在最后两位，FF=完全不透明）
 */
const MapColorSelector: React.FC = () => {
  const { formatMessage } = useIntl();
  const { value, setValue } = useSettingObjectState('map_colors');

  const handleChange = useCallback(
    (newValue: IMapColorsValue) => {
      setValue(newValue);
    },
    [setValue],
  );

  const handleReset = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      setValue(cloneMapColorsDefault());
    },
    [setValue],
  );

  return (
    <ConfigCard
      title={formatMessage({ id: 'dbl_chart_map_title' })}
      operation={(
        <Button type="link" onClick={handleReset}>
          {formatMessage({ id: 'dbl_chart_map_restore' })}
        </Button>
      )}
      className="dbl-map-color"
    >
      <ColorTheme {...value} onChange={handleChange} />
    </ConfigCard>
  );
};

export default React.memo(MapColorSelector);
